import moment from 'moment'

export const TIN_TUC_PAGE_SIZE = 10
export const TIN_TUC_EMPTY_INITIAL = '?'

export const TIN_TUC_ROUTES = {
  list: '/utility/general-notifications',
  listSelected: id => `/utility/general-notifications?selectedId=${id}`,
  create: '/utility/general-notifications/create',
  update: id => `/utility/general-notifications/update/${id}`,
  view: id => `/utility/general-notifications/view/${id}`,
}

export const getTinTucAuthorName = tinTuc =>
  tinTuc?.author?.name_lowercase ||
  tinTuc?.author?.name ||
  tinTuc?.created_by?.name_lowercase ||
  tinTuc?.created_by?.name ||
  tinTuc?.createdBy?.name_lowercase ||
  tinTuc?.createdBy?.name ||
  tinTuc?.author_name ||
  tinTuc?.create_user ||
  'Không rõ người đăng'

export const getTinTucInitialName = tinTuc =>
  (getTinTucAuthorName(tinTuc) || TIN_TUC_EMPTY_INITIAL)
    .split('')[0]
    .toString()
    .toUpperCase()

export const getTinTucFormattedDate = tinTuc => {
  const dateValue =
    tinTuc?.created_date ||
    tinTuc?.updated_date ||
    tinTuc?.created_at ||
    tinTuc?.createdAt
  if (!dateValue) return ''
  const parsed = moment(dateValue)
  return parsed.isValid() ? parsed.format('DD/MM/YYYY HH:mm') : ''
}
